<template>
  <div id="app">
    <global-header></global-header>
    <div class="main-view">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

import GlobalHeader from './components/GlobalHeader'

export default {
  name: 'app',
  components: {
    GlobalHeader,
  },
}
</script>

<style scoped>
.main-view{
  position: absolute;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #f2f2f2;
  padding: 8px;
}
</style>

<style>

body, p{
  padding: 0;
  margin: 0;
}

body{
  font-size: 12px;
  font-family: 'Microsoft YaHei';
  color: #666;
}

/* 鼠标为手样式 */
.pointer{
  cursor: pointer;
}

/* 链接样式 */
.link{
  color: #3875f6;

  &:hover{
    text-decoration: underline;
  }
}

/* 按钮样式 */
.el-button.el-button--confirm, .el-button.el-message-box .el-button--primary{
  width: 96px;
  height: 32px;
  padding: 0;
  text-align: center;
  line-height: 32px;
  border-color: #e72528;
  color: #fff;
  background: #e72528;
  outline: none;

  &:hover, &.is-disabled, &.is-disabled:hover{
    border-color: #e72528;
    color: #fff;
    background: rgba(231,37,40,.7);
  }
  &.is-disabled, &.is-disabled:hover{
    opacity: 0.6;
  }
  &:active{
    border-color: #e72528;
    color: #fff;
    background: rgba(231,37,40,.7);
  }
  &:focus{
    border-color: #e72528;
    color: #fff;
    background: rgba(231,37,40,.7);
  }
}

.el-button.el-button--cancel, .el-button.el-message-box .el-button--default{
  width: 96px;
  height: 32px;
  padding: 0;
  text-align: center;
  line-height: 32px;
  border: 1px solid #e5e5e5;
  color: #666;
  outline: none;

  &:hover{
    border-color: #e5e5e5;
    color: #666;
    background: #f2f2f2;
  }
  &:active{
    border-color: #e5e5e5;
    color: #666;
    background: #f2f2f2;
  }
  &:focus{
    border-color: #e5e5e5;
    color: #666;
    background: #f2f2f2;
  }
}

.ft14{
  font-size: 14px;
}

.ftbold{
  font-weight: bold;
}

.ftnormal{
  font-weight: normal;
  font-style: normal;
}

.underline{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/App.vue